import { Injectable, signal } from '@angular/core';

@Injectable()
export class LayoutService {
  // states
  public windowIsOpen = signal<boolean>(false);
  public hiddenMegaMenu = signal<boolean>(true);
  public hiddenAdvancedFilters = signal<boolean>(true);
  public hiddenProfileMenu = signal<boolean>(true);
  public titleSubject = signal<string>('defaultTitleKey');

  setTitleKey(titleKey: string) {
    this.titleSubject.set(titleKey);
  }
}
